import firebase from '../Firebase/Firebase';

const call = (name) => firebase.app().functions('europe-west1').httpsCallable(name);

export const getStripePublicConfig = async () => {
  const result = await call('getStripePublicConfig')({});
  return result.data;
};

export const createStripeAccountSession = async (component = 'account-onboarding') => {
  const result = await call('createStripeAccountSession')({ component });
  return result.data;
};

export const getStripeConnectStatus = async () => {
  const result = await call('getStripeConnectStatus')({});
  return result.data;
};

export const recreateMyStripeConnectAccount = async () => {
  const result = await call('recreateMyStripeConnectAccount')({});
  return result.data;
};

export const getArtisanFinanceSummary = async () => {
  const result = await call('getArtisanFinanceSummary')({});
  return result.data;
};


export const submitProtectedContract = async ({ demandId, contract }) => {
  const result = await call('submitProtectedContract')({ demandId, contract });
  return result.data;
};

export const acceptContractSecurely = async ({ demandId, consent }) => {
  const result = await call('acceptContractSecurely')({ demandId, consent });
  return result.data;
};

export const createProjectDocumentPdf = async ({ demandId, type, language = 'fr' }) => {
  const result = await call('createProjectDocumentPdf')({ demandId, type, language });
  return result.data;
};

export const createMilestoneCheckout = async ({ demandId, milestone }) => {
  const result = await call('createMilestoneCheckout')({
    demandId,
    milestone,
    returnOrigin: typeof window !== 'undefined' ? window.location.origin : '',
  });
  return result.data;
};

export const reconcileMilestonePayment = async ({ demandId, milestone, sessionId = '' }) => {
  const result = await call('reconcileMilestonePayment')({ demandId, milestone, sessionId });
  return result.data;
};
